module.exports = "/_next/static/media/9554022cf0671979cee48c82d1bd2917.svg";